import React from "react";
import CommonStaticSidebar from "./commonStaticSidebar";
import API from "../../api";
import moment from "moment";
import Article from "../Common/article";
import FoodCard from "../Common/foodCard";
import {instanceOf} from "prop-types";
import {Cookies, withCookies} from "react-cookie";
import {images} from "../../constant";
import BestSellerGrid from "./bestSellerGrid";
import {Helmet} from "react-helmet";
import {BASE_URL} from "../../helper";
const api = new API();

class SingleBlog extends React.Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            blog: null,
            default_store : this.props.cookies.get('selected_store') !== undefined ? this.props.cookies.get('selected_store') : 2,
            scrollX: 0,
            scrolEnd: false,
            all_products: [],
        };
        this.scrl = React.createRef();
    }

    //Slide click
    slide = (shift) => {
        this.scrl.current.scrollLeft += shift;
        this.setState({scrollX: scrollX + shift});
        if (
            Math.floor(this.scrl.current.scrollWidth - this.scrl.current.scrollLeft) <=
            this.scrl.current.offsetWidth
        ) {
            this.setState({scrolEnd: true});
        } else {
            this.setState({scrolEnd: false});
        }
    };

    scrollCheck = () => {
        this.setState({scrollX: this.scrl.current.scrollLeft});
        if (
            Math.floor(this.scrl.current.scrollWidth - this.scrl.current.scrollLeft) <=
            this.scrl.current.offsetWidth
        ) {
            this.setState({scrolEnd: true});
        } else {
            this.setState({scrolEnd: false});
        }
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        const slug = this.props.match.params.blog_slug ;
        api.getSingleBlog(slug).then(blogs => {
            this.setState({blog: blogs.data[0]});
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params.blog_slug !== this.props.match.params.blog_slug ){
            const slug = this.props.match.params.blog_slug ;
            api.getSingleBlog(slug).then(blogs => {
                this.setState({blog: blogs.data[0]});
            });
        }
        if (this.props.cookies.get('selected_store') !== undefined && this.props.cookies.get('selected_store') !== this.state.default_store){
            this.setState({default_store: this.props.cookies.get('selected_store') });
        }
    }

    render() {

        const category = this.state.blog?.["_embedded"]["wp:term"][0].map(u => u.name).join(' | ');
        const image = this.state.blog?.["_embedded"]["wp:featuredmedia"]?.[0]["media_details"]  ?  this.state.blog["_embedded"]?.["wp:featuredmedia"]?.[0]?.["media_details"]?.["sizes"]?.["medium"]?.["source_url"] : images.blog_place ;
        const author = this.state.blog?.["_embedded"]["author"][0]["name"];
        const sort_description = this.state.blog?.["acf"]["short_description"];
        const main_description = this.state.blog?.["content"]["rendered"];
        const button_text = this.state.blog?.["acf"]["button_text"];
        const button_link = this.state.blog?.["acf"]["button_link"];

        return (
            <>
                <React.Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>{this.state.blog?.title?.rendered}</title>
                        <meta name="description" content={sort_description}/>
                        <meta name="robots" content="index, follow"/>
                        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                        <meta property="og:type" content="article"/>
                        <meta property="og:title" content={this.state.blog?.title?.rendered}/>
                        <meta property="og:description" content={sort_description}/>
                        <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                        <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                        <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                        <meta property="article:modified_time" content="2022-02-28T13:10:39+00:00"/>
                        <meta property="og:image" content={images.logoImg}/>
                        <meta property="og:image:width" content="1449"/>
                        <meta property="og:image:height" content="1024"/>
                        <meta name="twitter:card" content="summary"/>
                        <meta name="twitter:creator" content="Farmerfreshmeat"/>
                        <meta name="twitter:site" content="Farmerfreshmeat"/>
                        <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                        <script type="application/ld+json" className="yoast-schema-graph">{` {"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://farmersfreshmeat.com/#organization","name":"Farmer's Fresh Meat","url":"https://farmersfreshmeat.com/","sameAs":["https://www.facebook.com/farmersfreshmeat","https://www.instagram.com/farmersfreshmeat/","https://www.youtube.com/user/farmersfreshmeat","https://www.pinterest.com/Farmerfreshmeat/","https://twitter.com/Farmerfreshmeat"],"logo":{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/#logo","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2015/03/Farmers_Fresh_Meat_Logo.png","width":312,"height":79,"caption":"Farmer's Fresh Meat"},"image":{"@id":"https://farmersfreshmeat.com/#logo"}},{"@type":"WebSite","@id":"https://farmersfreshmeat.com/#website","url":"https://farmersfreshmeat.com/","name":"Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop","description":"Farmers Fresh Meat","publisher":{"@id":"https://farmersfreshmeat.com/#organization"},"potentialAction":[{"@type":"SearchAction","target":"https://farmersfreshmeat.com/?s={search_term_string}","query-input":"required name=search_term_string"}],"inLanguage":"en-US"},{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2019/09/Leg-Quarters-3-scaled.jpg","width":1449,"height":1024},{"@type":"WebPage","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#webpage","url":"https://farmersfreshmeat.com/shop/leg-quarters/","name":"Fresh Chicken Leg Quarters By the Pound - On Sale now!","isPartOf":{"@id":"https://farmersfreshmeat.com/#website"},"primaryImageOfPage":{"@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage"},"datePublished":"2019-09-23T15:14:32+00:00","dateModified":"2022-02-28T13:10:39+00:00","description":"Fresh Chicken Leg Quarters on Sale and Priced per pound. Hormone free and cut free of charge. The best price and quality at Farmer's Fresh Meat!","inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://farmersfreshmeat.com/shop/leg-quarters/"]}]}]}`}</script>
                    </Helmet>
                    <div>
                        <div className="container-fluid about-content mt-3">
                            <div className="col-12">
                                <div className="row">
                                    <CommonStaticSidebar/>

                                   {this.state.blog && this.state.blog?.title &&
                                    <div className="col-md-9 emp-form">
                                        <div className="row">
                                            <div className="col-md-12 p-0">
                                                <div className="col-12 main-section bg-white p-4 text-left">
                                                    <div className="col-12 mb-md-4 mb-3 px-0">
                                                        <small className="text-muted text-uppercase font-weight-medium font-12">{category}</small>
                                                        <h1 className="my-2 art-head">{this.state.blog?.title?.rendered}</h1>
                                                        {/*<hr className="bg-theme opacity-100 m-0 mb-3"*/}
                                                        {/*    style={{width: "40px", height: "2px"}}/>*/}
                                                        {/*<h6 className="text-capitalize text-black mb-0">Written by {author}</h6>*/}
                                                        <h6 className="text-muted text-capitalize">Posted on: {this.state.blog?.date ? moment(this.state.blog?.date).format('LL') : ""}</h6>
                                                    </div>
                                                    {sort_description &&
                                                       <h6><p className="desc mb-0" dangerouslySetInnerHTML={{__html: sort_description}}/></h6>
                                                    }
                                                    <img className="img-fluid w-100 img-rounded" src={image} />
                                                    {button_link &&
                                                        <div className="col-12 text-center mb-2 px-0">
                                                            <a type="button" target="_blank" href={button_link}
                                                               className="btn btn-order py-2 px-4 mx-auto w-auto">{button_text}</a>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            {main_description &&
                                                <div className="col-md-12 p-0">
                                                    <div className="col-12 blog-desc main-section bg-white p-4 text-left">
                                                        <div className="title mb-0 px-0">
                                                            <p className="desc mb-0"
                                                               dangerouslySetInnerHTML={{__html: main_description}}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <div className="col-12 text-center title pl-3 mb-3 mt-3">
                                                <h2 className="">Checkout Our Bestsellers</h2>
                                                <BestSellerGrid />
                                            </div>
                                        </div>
                                    </div>
                                    }

                                </div>
                            </div>
                        </div>
                        <div className="col-12 article-related p-0">
                            <Article id={this.state.blog?.id}/>
                        </div>
                    </div>
                </React.Fragment>
            </>
        );
    }
}

export default withCookies(SingleBlog);



